module.exports = __webpack_public_path__ + "static/media/trade-r-logo-dark-gradient.34c7bf56.png";